var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from "react";
import withModal from "../../HOCs/withModal";
import usePagedSortedTable, { TotalPageMappers, } from "../../Hooks/usePagedSortedTable";
import TranscriptCourseService from "../../../Services/TranscriptCourse.service";
import DateService from "../../../Services/Shared/Date.service";
import useCheckboxes from "../../Hooks/useCheckboxes";
import TermAttendanceStatusBadge from "../../Presentational/TermAttendanceStatus/TermAttendanceStatusBadge";
import { ModalCloseButton } from "../../UI/StandardButtons/StandardButtons";
import SecondaryNavButton from "../../UI/SecondaryNav/SecondaryNavButton";
import FAIcon from "../../UI/FAIcon/FAIcon";
import SecondaryNavLayout from "../../Layout/SecondaryNavLayout";
import MarkAsStoppedNeverAttendedModal from "./MarkAsStoppedNeverAttendedModal";
import { InlineFormFormat } from "../../UI/FormFormat/FormFormat";
import SearchField from "../../Form/SearchField";
import { TermAttendanceStatusMultiSearch } from "../../Presentational/TermAttendanceStatus/TermAttendanceStatusSearch";
import DateRangeField from "../../Form/DateRangeField";
import SelectField from "../../Form/SelectField";
import NewMessageModal from "../../Presentational/Message/NewMessageModal";
import AlertModal from "../../Presentational/Alert/AlertModal";
const PAGE_SIZE = 30;
const ManageNeverStoppedAttendingModal = withModal((props) => {
    const { checkedItems, getCheckbox, unCheckEverything } = useCheckboxes({
        equalsFunc: (a, b) => a.transcriptCourse.transcriptCourseId ===
            b.transcriptCourse.transcriptCourseId,
    });
    const [formState, setFormState] = useState({});
    const [newMessageModalIsOpen, setNewMessageModalIsOpen] = React.useState(false);
    const [alertModalIsOpen, setAlertModalIsOpen] = React.useState(false);
    const { table, refresh } = usePagedSortedTable({
        getData: (sort, page, sArgs) => {
            var _a, _b, _c, _d;
            let order = sort === null || sort === void 0 ? void 0 : sort.order;
            if ((sort === null || sort === void 0 ? void 0 : sort.sort) === "TRANSCRIPT_COURSE_LAST_ATTENDED_DATE") {
                // @ts-expect-error - TS2322 - Type '"ascnullsfirst" | "descnullslast"' is not assignable to type '"desc" | "asc" | undefined'.
                order = sort.order === "asc" ? "ascnullsfirst" : "descnullslast";
            }
            return TranscriptCourseService.search({
                courseSectionIds: [props.courseSectionId],
                hasAttended: (_a = sArgs.hasAttended) === null || _a === void 0 ? void 0 : _a.value,
                lastAttendanceDateFrom: (_b = sArgs.lastAttendedFrom) === null || _b === void 0 ? void 0 : _b.toDate(),
                lastAttendanceDateTo: (_c = sArgs.lastAttendedTo) === null || _c === void 0 ? void 0 : _c.toDate(),
                termAttendanceStatusIds: (_d = sArgs.termAttendanceStatuses) === null || _d === void 0 ? void 0 : _d.map((status) => status.id),
            }, {
                sort: sort === null || sort === void 0 ? void 0 : sort.sort,
                order,
                offset: page * PAGE_SIZE,
                max: PAGE_SIZE,
            });
        },
        searchArgs: formState,
        addCheckboxes: {
            useCheckboxesMakeCheckbox: getCheckbox,
            getCheckedItem: (data, index) => data.data[index],
        },
        initialSort: {
            sort: "TRANSCRIPT_COURSE_LAST_ATTENDED_DATE",
            order: "asc",
        },
        getNumPages: (result) => TotalPageMappers.EngagePagedResult(result, PAGE_SIZE),
        columns: [
            {
                title: "Name",
                sortId: "PERSON_LAST_NAME",
            },
            {
                title: "Last Attendance Date",
                sortId: "TRANSCRIPT_COURSE_LAST_ATTENDED_DATE",
            },
            {
                title: "Term Attendance Status",
                sortId: "TRANSCRIPT_COURSE_ATTENDANCE_STATUS",
            },
        ],
        rows: ({ data }) => data.map(({ person, transcriptCourse }) => [
            `${person.firstName} ${person.lastName} (${person.studentId})`,
            transcriptCourse.lastAttendanceDate
                ? DateService.displayLong(transcriptCourse.lastAttendanceDate)
                : "",
            _jsx(TermAttendanceStatusBadge, { status: transcriptCourse.termAttendanceStatus }, 2),
        ]),
    });
    const [isMarkAsModalOpen, setIsMarkAsModalOpen] = useState(false);
    return (_jsxs(_Fragment, { children: [_jsxs(SecondaryNavLayout, { dontFix: true, nav: _jsxs("div", { className: "d-flex align-items-center justify-content-between flex-grow-1", children: [_jsxs("div", { className: "d-flex", children: [_jsx(SecondaryNavButton, { icon: "tasks", label: "Mark As", disabled: !checkedItems.length, onClick: () => setIsMarkAsModalOpen(true) }), _jsx(SecondaryNavButton, { onClick: () => setNewMessageModalIsOpen(true), icon: "envelope", label: "Message", disabled: !checkedItems.length, title: checkedItems.length
                                        ? `Send selected students a message`
                                        : "Select at least one student to send a message to" }), _jsx(SecondaryNavButton, { icon: "bell", label: "Alert", onClick: () => setAlertModalIsOpen(true), disabled: !checkedItems.length, title: checkedItems.length
                                        ? "Create an alert for selected students"
                                        : "Select at least one student to create an alert for" }), _jsx(MarkAsStoppedNeverAttendedModal, { students: checkedItems.map(({ person, transcriptCourse }) => ({
                                        personFirstName: person.firstName,
                                        personLastName: person.lastName,
                                        transcriptCourseId: transcriptCourse.transcriptCourseId,
                                    })), onSuccess: () => {
                                        refresh();
                                        if (props.onSuccessfullyMarkedTermAttendanceStatus) {
                                            props.onSuccessfullyMarkedTermAttendanceStatus();
                                        }
                                    }, isOpen: isMarkAsModalOpen, onModalClosed: () => setIsMarkAsModalOpen(false) })] }), _jsx("button", { className: "btn btn-link text-dark", onClick: () => props.onModalClosed(), children: _jsx(FAIcon, { icon: "times", title: "Close", srText: "Close this modal" }) })] }), children: [_jsxs("div", { className: "modal-body", children: [_jsx("h1", { className: "h2 mb-3", children: "Manage Stopped/Never Attended" }), _jsx("div", { className: "mb-3", children: _jsxs(InlineFormFormat, { saveButtonContents: "Search", handleSubmit: (state) => __awaiter(void 0, void 0, void 0, function* () {
                                        setFormState(state);
                                    }), children: [_jsx(SearchField, { label: "Term Attendance Status", name: "termAttendanceStatuses", as: (provided) => (_jsx(TermAttendanceStatusMultiSearch, Object.assign({}, provided))) }), _jsx(DateRangeField, { nameStart: "lastAttendedFrom", placeHolderStart: "Last Attend From", placeHolderEnd: "To", nameEnd: "lastAttendedTo", size: "extra-wide" }), _jsx(SelectField, { label: "Has Attended", name: "hasAttended", options: [
                                                { label: "Yes", value: true },
                                                { label: "No", value: false },
                                            ] })] }) }), table] }), _jsx("div", { className: "modal-footer", children: _jsx(ModalCloseButton, { onClick: () => props.onModalClosed() }) })] }), _jsx(NewMessageModal, { recipientAffiliationIds: checkedItems.map(({ person }) => person.affiliationId), onModalClosed: () => {
                    setNewMessageModalIsOpen(false);
                }, onMessageSend: () => {
                    unCheckEverything();
                }, isOpen: newMessageModalIsOpen, size: "lg" }), _jsx(AlertModal, { studentAffiliationIds: checkedItems.map(({ person }) => person.affiliationId), onModalClosed: () => {
                    setAlertModalIsOpen(false);
                }, courseSectionId: props.courseSectionId, isOpen: alertModalIsOpen, modalId: "alertModalInManageAttend", onSendAlert: () => {
                    if (props.onSendAlert) {
                        props.onSendAlert();
                    }
                    unCheckEverything();
                }, size: "lg" })] }));
}, { defaultModalProps: { size: "xl", unMountContentWhenClosed: true } });
export default ManageNeverStoppedAttendingModal;
